import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full bg-brand-black my-auto px-4 pt-14 z-50" }
const _hoisted_2 = { class: "flex flex-col space-y-6" }
const _hoisted_3 = { class: "flex flex-col w-full space-y-2" }
const _hoisted_4 = {
  key: 0,
  class: "flex text-white text-2xl font-medium"
}
const _hoisted_5 = {
  key: 1,
  class: "flex text-white text-2xl font-medium"
}
const _hoisted_6 = { class: "flex space-x-2" }
const _hoisted_7 = { class: "flex m-auto space-x-2.5" }
const _hoisted_8 = { class: "my-auto pt-0.5" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

import {
  IonContent,
  IonPage, onIonViewDidEnter, onIonViewWillEnter, useIonRouter,
} from '@ionic/vue';
import {computed, defineComponent, onMounted, ref} from 'vue';
import InputTextarea from "@/components/InputTextarea.vue";
import AuthService from "@/services/api/auth/authService";
import {v4 as uuidv4} from 'uuid';
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {Preferences} from "@capacitor/preferences";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import {AccountType} from "@/definitions/AccountType";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountOnboardingBioPage',
  setup(__props) {

const busy = ref(false)
const bio = ref('')

const errors = ref({})
const ionRouter = useIonRouter()
const accountType = ref()

onIonViewWillEnter(async () => {
  Observable.emit(ObservableEvent.IonRouterOutletChanged, ionRouter.canGoBack())
  accountType.value = (await Preferences.get({key: PreferenceKey.OnboardingAccountType})).value
})

const forward = async () => {
  if (!bio.value || busy.value) return
  busy.value = true
  errors.value = {}
  try {
    if (accountType.value === AccountType.Club) await ionRouter.navigate('/account/onboarding/profile-picture', 'forward', 'push')
    if (accountType.value !== AccountType.Club) await ionRouter.navigate('/account/onboarding/interested-in', 'forward', 'push')
    await ApiService.User().setBio(bio.value)
  } catch (e: any) {
    if (!e.data) return
    if (e.data.errors) errors.value = e.data.errors
  } finally {
    busy.value = false
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (accountType.value !== _unref(AccountType).Club)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, "All about you "))
                  : _createCommentVNode("", true),
                (accountType.value === _unref(AccountType).Club)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "About your club "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(InputTextarea, {
                  modelValue: bio.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bio).value = $event)),
                  placeholder: accountType.value !== _unref(AccountType).Club ? 'Introduce yourself...' : 'Tell us about your club or business...',
                  enterkeyhint: "next",
                  counter: true,
                  error: errors.value && errors.value.hasOwnProperty('bio') ? errors.value['bio'][0] : null,
                  maxLength: 2000
                }, null, 8, ["modelValue", "placeholder", "error"])
              ])
            ]),
            _createElementVNode("button", {
              onClick: forward,
              class: _normalizeClass([{
              'bg-opacity-40' : !bio.value
            }, "mt-10 flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (!busy.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Continue"))
                    : _createCommentVNode("", true),
                  (busy.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("svg", {
                          class: "animate-spin h-5 w-5 text-brand-black",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})